import Api from "./axiosInstance";
import config from "../../utils/config/config";
import axios from "axios";
import { isUserOnline } from "../storage/LocalStorage";
import { buildRequest } from "../../services/socket/initWebSocket";

const loginUser = async (email, password, appType, otpToken) => {
  try {
    const payload = {
      email,
      password,
      platform: "web",
      appType,
      ...(otpToken && { otpToken }),
    };

    const req = buildRequest("AuthService", "FrontmSignin", payload);
    const response = await Api.post(req);
    return response.data;
  } catch (error) {
    console.error("Login failed:", error);
    throw error;
  }
};

const getDomainUser = async () => {
  try {
    const req = buildRequest("UserService", "GetUserDomains", {});
    const response = await Api.post(req);
    return response.data;
  } catch (error) {
    console.error("Get domain user failed:", error);
    throw error;
  }
};

const getUserProfilePic = (userId) =>
  `${config.userImageBaseUrl}/${userId}_75x75.png`;

const updateLastLoggedInDomain = async (data) => {
  try {
    const req = buildRequest(
      "UserService",
      "UpdateLastLoggedInDomain",
      data
    );
    const response = await Api.post(req);
    return response.data;
  } catch (error) {
    console.error("Update last logged-in domain failed:", error);
    throw error;
  }
};

const doGoogleSignin = async (data) => {
  if (!isUserOnline()) return;

  try {
    const req = buildRequest("AuthService", "GoogleSignin", data);
    const response = await Api.post(req);
    return response.data;
  } catch (error) {
    console.error("Google signin failed:", error);
    throw error;
  }
};

const loginWithJWT = async (params) => {
  try {
    const response = await axios.post(config.jwtLoginURL, params, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": config.xApiKeyForJwtLogin,
      },
    });
    return response.data;
  } catch (error) {
    console.error("JWT login failed:", error);
    throw error;
  }
};

export default {
  loginUser,
  getDomainUser,
  getUserProfilePic,
  updateLastLoggedInDomain,
  doGoogleSignin,
  loginWithJWT,
};
